import PropTypes from 'prop-types';
import React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal, {ModalButton} from 'ui-library/modals/Modal';
import {TextAreaChangeEvent} from 'util/Types';

interface ImportSchemaFieldSelectorOptionsModalProps {
  onRequestClose: () => void;
  onRequestSubmit: (options: Array<string>) => void;
  existingOptionNames: Array<string>;
}

interface State {
  optionsText: string;
  invalidOptionNames: Array<string>;
  repeatedOptionNames: Array<string>;
}

class ImportSchemaFieldSelectorOptionsModal extends React.Component<
  ImportSchemaFieldSelectorOptionsModalProps,
  State
> {
  static propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    onRequestSubmit: PropTypes.func.isRequired,
    existingOptionNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  };

  state: State = {
    optionsText: '',
    invalidOptionNames: [],
    repeatedOptionNames: [],
  };

  _handleSubmit = (): void => {
    const optionNames = this.state.optionsText
      .split('\n')
      .map((optionName) => optionName.trim())
      .filter((optionName) => optionName !== '');
    const invalidOptionNames = optionNames.filter((optionName) =>
      this.props.existingOptionNames.includes(optionName)
    );
    let repeatedOptionNames = optionNames.filter(
      (optionName, index) => optionNames.indexOf(optionName) !== index
    );
    repeatedOptionNames = [...new Set(repeatedOptionNames)];
    if (invalidOptionNames.length > 0 || repeatedOptionNames.length > 0) {
      this.setState({invalidOptionNames, repeatedOptionNames});
    } else {
      this.props.onRequestSubmit(optionNames);
    }
  };

  _getButtons(): Array<ModalButton> {
    return [
      {
        key: 'import',
        style: ButtonStyle.PRIMARY,
        disabled: !this.state.optionsText,
        submit: true,
        text: 'Import options',
      },
    ];
  }

  _handleChangeOptionsText = (e: TextAreaChangeEvent): void => {
    this.setState({optionsText: e.target.value});
  };

  render(): JSX.Element {
    return (
      <Modal
        className="schemaFieldSelectorOptionsModal"
        title="Import options"
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this._handleSubmit}
        buttons={this._getButtons()}
      >
        <div>
          <span>Enter the desired options, one option per line.</span>
          <textarea
            autoFocus={true}
            onChange={this._handleChangeOptionsText}
            value={this.state.optionsText}
            rows={8}
          />
          {this.state.invalidOptionNames.length > 0 && (
            <div className="alert alert-danger u-mini-spacing-top u-mini-spacing-bottom">
              <span>The following options already exist for the dropdown; please remove them.</span>
              <ul>
                {this.state.invalidOptionNames.map((optionName, index) => (
                  <li key={index}>{optionName}</li>
                ))}
              </ul>
            </div>
          )}
          {this.state.repeatedOptionNames.length > 0 && (
            <div className="alert alert-danger u-mini-spacing-top u-mini-spacing-bottom">
              <span>The following options were repeated; please remove duplicate lines.</span>
              <ul>
                {this.state.repeatedOptionNames.map((optionName, index) => (
                  <li key={index}>{optionName}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

export default ImportSchemaFieldSelectorOptionsModal;
